import { Partner } from "features/settings/importMapping/partner";

export enum ErpSystem {
    Agris = 1,
    AgTrax = 2,
    Oakland = 3,
    Agvance = 4,
    EverAg = 5,
    AgVantage = 6,
    AgVision = 7,
    AgTech = 8,
    Intellego = 9,
    Vertical = 10,
    AgrisDataHub = 11
}

export interface PartnerOptions {
    partner: Partner;
    isHedgeOrderExportSupported: boolean;
}

export function getErpSystemName(erpSystem: ErpSystem): string {
    return ErpSystem[erpSystem] ?? "Unknown ERP system";
}

export function isAgrisErp(erpSystem: Nullish<ErpSystem>) {
    return erpSystem != null && [ErpSystem.Agris, ErpSystem.AgrisDataHub].includes(erpSystem);
}

export function getErpSystemsForPartner(partner: Partner): ErpSystem[] {
    switch (partner) {
        case Partner.AgTrax:
            return [ErpSystem.AgTrax];
        case Partner.Agris:
            return [ErpSystem.Agris];
        case Partner.Oakland:
            return [ErpSystem.Oakland];
        case Partner.Agvance:
            return [ErpSystem.Agvance];
        case Partner.EverAg:
            return [ErpSystem.EverAg];
        case Partner.AgVantage:
            return [ErpSystem.AgVantage];
        case Partner.AgVision:
            return [ErpSystem.AgVision];
        case Partner.AgTech:
            return [ErpSystem.AgTech];
        case Partner.Intellego:
            return [ErpSystem.Intellego];
        case Partner.Vertical:
            return [ErpSystem.Vertical];
        case Partner.AgrisDataHub:
            return [ErpSystem.AgrisDataHub];
        default:
            throw new Error("Unrecognized import system " + partner);
    }
}